import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete, InputAdornment } from "@mui/material";
import { createTheme } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import EmailIcon from "@mui/icons-material/Email";
import Checkbox from "@material-ui/core/Checkbox";
// import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
// import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import subDays from "date-fns/subDays";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import CancelIconButton from "../buttons/CancelIconButton";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../../redux/store";
// import AddressWithTimezone from "../address/AddressWithTimezone";
import SaveButton from "../buttons/SaveButton";
import "./Event.css";
// import DeleteIcon from "@material-ui/icons/Delete";
import EditIconButton from "../buttons/EditIconButton";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import PurchaseEventPlan from "./PurchaseEventPlan";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import EventCreditCardForm from "./EventCreditCardForm";
import moment from "moment-timezone";
import OveragesLockIcon from "../../../assets/img/overagesLock.png";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#008181",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: "white",
        color: "#005476",
      },
    },
  },
});
class Event extends Component {
  header = store.getState().header.header;
  companyName =
    store.getState().appUserData.appUserData.appuser?.organization?.name;
  defaultCountry = store.getState().staticData.defaultCountry;
  countryListArray = store.getState().staticData.countryList;
  eventTypeList = store.getState().staticData.eventTypes;
  cventDataCarryoverTypes = store.getState().staticData.cventDataCarryoverTypes;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  smsCredits = store.getState().businessDomain?.smsCredits;
  eventBusinessDomain = store.getState().businessDomain?.eventState;
  eventTimeZone = store.getState().businessDomain?.eventTimeZone;
  planType = store.getState().appUserData.appUserData.planType?.type;
  eventState = store.getState().applicationState.eventState;
  activeChildMenu = store.getState().activeMenu.activeChildMenu;
  accountSettings = store.getState().accountSetting?.accountSetting;
  regionList = store.getState().staticData.regionList;
  addressRef = React.createRef();
  stateListArray = [];
  interval = null;
  breadCrumb = [
    { pageid: "/eventMgmt", uiname: "Event List" },
    { pageid: "", uiname: "Event" },
  ];
  constructor(props) {
    super(props);
    let action = props.action;
    let eventId = props.eventId;
    if (!action && props.state) {
      action = props.state.action;
      eventId = props.state.eventId;
    }
    if (null !== eventId && eventId > 0) {
      this.getEventDetails(eventId);
    }
    // if (action === "create") {
    //   this.handleCountryChange(this.defaultCountry);
    // }
    const selectedRegion = this.regionList?.length > 0 ? this.regionList[0] : null;
    this.state = {
      action: action,
      regionList: this.regionList,
      region: selectedRegion,
      timeZoneListArray: selectedRegion?.timeZones || [],
      startDate: null,
      endDate: null,
      requestedStartDate: null,
      requestedEndDate: null,
      eventName: "",
      eventPlanId: "",
      location: "",
      country: this.defaultCountry,
      state: null,
      timeZone: null,
      approxAttendees: "",
      registrationConfirmationText: "",
      beforeTextcount: "",
      onTextcount: "",
      afterTextcount: "",
      ceventCarryover: null,
      eventType: null,
      eventPlan: null,
      address: {},
      eventPlanList: [],
      stateListArray: [],
      countryListArray: this.countryListArray,
      getUpdatePermission: false,
      getDeletePermission: false,
      isConnectToCvent: false,
      errorMassage: false,
      endDateErrorMassage: false,
      purchasePlan: false,
      sendEmailOpen: false,
      error: false,
      requestError: false,
      requestErrorMassage: false,
      eventPurchasePlan: false,
      processing: false,
      cardError: null,
      eventStatus: null,
      render: false,
    };
  }
  componentDidMount() {
    const postObject = { header: this.header };

    if (
      this.state.action !== "view" &&
      Utils.equalsIgnoreCase(this.planType, "Onetime")
    ) {
      FetchServerData.callPostService("/planms/getForEventText", postObject)
        .then((output) => {
          if (output.status === "SUCCESS") {
            let planList = (output.data.planList || [])?.filter(
              (plan) => plan.status?.status === "Active"
            );

            let updatedPlanList = planList.map((item) => ({
              ...item,
              isChecked: false,
            }));

            this.setState({
              render: true,
              eventPlanList: updatedPlanList,
              eventPlan: updatedPlanList[0] || null,
            });
          }
        })
        .catch((error) => { });
    }

    this.adjustTextareaHeight();
    this.interval = setInterval(() => this.forceUpdate(), 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  componentWillReceiveProps() {
    this.smsCredits = store.getState().businessDomain?.smsCredits;
    this.eventBusinessDomain = store.getState().businessDomain?.eventState;
    this.eventTimeZone = store.getState().businessDomain?.eventTimeZone;
  }

  getEventDetails(eventId) {
    const postObject = {
      header: this.header,
      event: {
        id: eventId,
      },
    };
    FetchServerData.callPostService("/eventms/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let eventDetails = output.data.event;
          let getPermission = Utils.getRolePermission(output.data?.privilegeList);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          // if (this.state.action === "edit") {
          //   this.handleCountryChange(eventDetails?.country);
          // }
          let smsCredits = eventDetails?.smsCredits;
          store.dispatch(SelectedDomainAction.setEventCreditUsage(smsCredits));
          store.dispatch(SelectedDomainAction.setEventTimezone(eventDetails?.timezone));
          let selectedRegion = eventDetails?.region;
          const matchedRegion = this.regionList?.find(
            (r) => r.id === selectedRegion?.id
          );


          this.setState({
            render: true,
            action: this.state.action !== "edit" ? "view" : "edit",
            eventId: eventDetails?.id,
            eventName: eventDetails?.name,
            eventType: eventDetails?.eventType,
            startDate: eventDetails?.startDate,
            endDate: eventDetails?.endDate,
            isConnectToCvent: eventDetails?.isConnectToCvent,
            ceventCode: eventDetails?.code,
            ceventCarryover: eventDetails.cventDataCarryoverType,
            registrationConfirmationText: eventDetails.registrationConfirmationText !== null ?
              eventDetails.registrationConfirmationText : "",
            approxAttendees: eventDetails?.approxAttendees,
            beforeTextcount: eventDetails?.beforeTextcount,
            onTextcount: eventDetails?.onTextcount,
            afterTextcount: eventDetails?.afterTextcount,
            address: eventDetails.address,
            eventStatus: eventDetails.status,
            eventPlan: eventDetails.eventPlan,
            location: eventDetails.location,
            region: eventDetails.region,
            timeZoneListArray: matchedRegion?.timeZones || [],
            country: eventDetails.country,
            state: eventDetails.state,
            timeZone: eventDetails?.timezone,
            isDatechangeRequested: eventDetails?.isDatechangeRequested,
            requestedStartDate: eventDetails?.requestedStartDate,
            requestedEndDate: eventDetails?.requestedEndDate,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        mobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleEventNameChange(e) {
    this.setState({ eventName: e.target.value });
  }
  handleEventTypeChange(selectedValue) {
    this.setState({ eventType: selectedValue });
  }

  handleStartDateChange(date) {
    let fromDate = Date.parse(date);
    let toDate = Date.parse(this.state.endDate);
    if (this.state.endDate === null && date === null) {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: false,
      });
    } else if (date === null) {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        startDate: date,
        error: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        startDate: date,
        error: false,
        errorMassage: false,
      });
    }
  }

  handleEndDateChange(date) {
    let fromDate = Date.parse(this.state.startDate);
    let toDate = Date.parse(date);

    if (this.state.startDate === null && date === null) {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: false,
        endDateErrorMassage: true,
      });
    } else if (this.state.startDate === null) {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: true,
        endDateErrorMassage: false,
      });
    } else if (fromDate > toDate) {
      this.setState({
        endDate: date,
        error: true,
        errorMassage: false,
        endDateErrorMassage: false,
      });
    } else {
      this.setState({
        endDate: date,
        error: false,
        errorMassage: false,
        endDateErrorMassage: false,
      });
    }
  }

  handleApproxAttendeeseChange(e) {
    this.setState({ approxAttendees: e.target.value });
  }

  handleIsConnectToCventChange(e) {
    this.setState({
      isConnectToCvent: e.target.checked,
    });
  }

  handleCeventCodeChange(e) {
    this.setState({ ceventCode: e.target.value });
  }

  handleCeventCarryoverChange(selectedValue) {
    this.setState({ ceventCarryover: selectedValue });
  }

  handleRegistrationConfirmationTextChange(e) {
    this.setState({ registrationConfirmationText: e.target.value });
    this.adjustTextareaHeight();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.registrationConfirmationText !== this.state.registrationConfirmationText) {
      this.adjustTextareaHeight();
    }
  }
  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  handleAddressChange(address) {
    this.setState({ address: address });
  }

  handleBeforeTextcountChange(e) {
    this.setState({ beforeTextcount: e.target.value });
  }
  handleOnTextcountChange(e) {
    this.setState({ onTextcount: e.target.value });
  }
  handleAfterTextcountChange(e) {
    this.setState({ afterTextcount: e.target.value });
  }

  // getRecommendedPlan() {
  //   const { approxAttendees, beforeTextcount, onTextcount, afterTextcount } =
  //     this.state;
  //   const combinedValue =
  //     Number(approxAttendees) *
  //     (Number(beforeTextcount) + Number(onTextcount) + Number(afterTextcount));
  //   if (combinedValue > 0) {
  //     return this.state.eventPlanList.find(
  //       (plan) => combinedValue <= plan.smsCredits
  //     );
  //   }
  // }

  getRecommendedPlan() {
    const {
      approxAttendees,
      beforeTextcount,
      onTextcount,
      afterTextcount,
      eventPlanList,
    } = this.state;

    const combinedValue =
      Number(approxAttendees) *
      (Number(beforeTextcount) + Number(onTextcount) + Number(afterTextcount));

    if (combinedValue > 0 && eventPlanList?.length > 0) {
      // Filter only "Onetime" plans
      const onetimePlans = eventPlanList?.filter(
        (plan) => plan?.planType?.type === "Onetime"
      );

      if (onetimePlans?.length === 0) return null; // No valid plans found

      // Sort plans by smsCredits (ascending)
      const sortedPlans = [...onetimePlans].sort(
        (a, b) => a.smsCredits - b.smsCredits
      );

      // Find the first plan where smsCredits is >= combinedValue
      let recommendedPlan = sortedPlans.find(
        (plan) => plan.smsCredits >= combinedValue
      );

      // If no such plan exists, take the last (largest) plan
      if (!recommendedPlan) {
        recommendedPlan = sortedPlans[sortedPlans?.length - 1];
      }

      return recommendedPlan;
    }

    return null;
  }
  handleEventPlanChange(plan) {
    this.setState({ eventPlan: plan });
  }
  createEventToBackend(data, stripe, elements) {
    const postObject = {
      header: this.header,
      event: {
        name: this.state.eventName,
        eventType: this.state.eventType,
        approxAttendees: this.state.approxAttendees,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        registrationConfirmationText: this.state.registrationConfirmationText,
        isConnectToCvent: this.state.isConnectToCvent,
        code: this.state.ceventCode,
        cventDataCarryoverType: this.state.ceventCarryover,
        beforeTextcount: this.state.beforeTextcount,
        onTextcount: this.state.onTextcount,
        afterTextcount: this.state.afterTextcount,
        location: this.state.location,
        // timezone: {
        //   id: this.state.timeZone?.id,
        // },
        region: {
          name: this.state.region?.name,
          code: this.state.region?.code,
          isActive: this.state.region?.isActive,
          displaySequence: this.state.region?.displaySequence,
          description: this.state.region?.description,
          id: this.state.region?.id,
        },
        timezone: this.state.timeZone,
        // country: { id: this.state.country?.id },
        // state: { id: this.state.state?.id },
        eventPlan: {
          id: this.state.eventPlan?.id,
        },
      },
      plan: {
        id: this.state.eventPlan?.id,
      },
    };
    FetchServerData.callPostService("/eventms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          // PtsAlert.success(output.message);
          let eventDetails = output.data.event;
          let eventId = eventDetails?.id;
          store.dispatch(SelectedDomainAction.setSelectedDomain(eventId));
          store.dispatch(SelectedDomainAction.setEventState(eventDetails));
          if (Utils.equalsIgnoreCase(this.planType, "Onetime")) {
            this.createClientSecretWithCard(data, eventId, stripe, elements);
            // this.setState({
            //   action: "PurchasePlan",
            //   eventPlanId: eventDetails.eventPlan?.id,
            //   eventId: eventDetails?.id,
            // });
            // this.props.navigate("/purchaseEventPlan", {
            //   state: {
            //     eventPlanId: eventDetails.eventPlan?.id,
            //     eventId: eventDetails?.id,
            //   },
            // });
          } else {
            this.props.navigate("/eventMgmt");
          }
        } else {
        }
      }
    );
  }
  createClientSecretWithCard = async (data, eventId, stripe, elements) => {
    this.setState({ processing: true, cardError: null });
    if (!stripe || !elements) {
      this.setState({
        cardError: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }
    // Step 2  Backend call to create client secret
    const postObject = {
      header: this.header,
      plan: { id: data.eventplan?.id },
      card: { id: data.creditCard?.id },
      eventId: eventId,
    };
    const resp = await FetchServerData.callPostService(
      "paymentms/createSecretWithCard",
      postObject
    );
    const clientSecret = resp.data.clientSecret;

    if (resp.status === "FAIL") {
      this.setState({
        cardError: resp.errorCode + resp.message,
        processing: false,
      });

      return;
    } else {
      // Step 3 Confirm the payment with card
      const result = await stripe.confirmCardPayment(clientSecret);

      if (result.error) {
        this.setState({
          cardError: result.error.message,
          processing: false,
        });
        return;
      }

      if (result && result.paymentIntent) {
        this.onPaymentSuccess(data, result.paymentIntent);
      }

      this.setState({ processing: false });
    }
  };

  async onPaymentSuccess(data, paymentIntent) {
    const postObject = {
      header: this.header,
      plan: { id: data.eventplan?.id },
      clientSecret: paymentIntent.client_secret,
      paymentIntentId: paymentIntent.id,
      cardName: data.cardName,
    };
    await FetchServerData.callPostService(
      "/paymentms/paymentSuccessful",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // PtsAlert.success(output.message);
        let orderPayment = output.data.orderPayment;
        if (orderPayment.isError) {
          this.setState({
            cardError: orderPayment.errorText,
            processing: false,
          });
        } else {
          this.props.navigate("/eventBillingInfo", {
            state: {
              pageId: "EventBilling",
            },
          });
          this.setState({
            render: true,
          });
        }
      } else {
      }
    });
  }

  createSubscriptionEventToBackend() {
    const postObject = {
      header: this.header,
      event: {
        name: this.state.eventName,
        eventType: this.state.eventType,
        approxAttendees: this.state.approxAttendees,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        registrationConfirmationText: this.state.registrationConfirmationText,
        isConnectToCvent: this.state.isConnectToCvent,
        code: this.state.ceventCode,
        cventDataCarryoverType: this.state.ceventCarryover,
        beforeTextcount: this.state.beforeTextcount,
        onTextcount: this.state.onTextcount,
        afterTextcount: this.state.afterTextcount,
        location: this.state.location,
        region: {
          name: this.state.region?.name,
          code: this.state.region?.code,
          isActive: this.state.region?.isActive,
          displaySequence: this.state.region?.displaySequence,
          description: this.state.region?.description,
          id: this.state.region?.id,
        },
        timezone: this.state.timeZone,
        // timezone: {
        //   id: this.state.timeZone?.id,
        // },
        // country: { id: this.state.country?.id },
        // state: { id: this.state.state?.id },
      },
    };
    FetchServerData.callPostService("/eventms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          // PtsAlert.success(output.message);
          let eventDetails = output.data.event;
          let eventId = eventDetails?.id;
          store.dispatch(SelectedDomainAction.setSelectedDomain(eventId));
          store.dispatch(SelectedDomainAction.setEventState(eventDetails));
          this.props.navigate("/eventMgmt");
        } else {
        }
      }
    );
  }

  createCancel() {
    this.props.navigate("/eventMgmt");
  }

  viewCancel() {
    // this.props.navigate("/eventMgmt");
    this.setState({
      action: "create",
      eventPurchasePlan: false,
    });
  }

  editCancel() {
    this.props.navigate(this.activeChildMenu);
  }

  editEventDetails(e) {
    this.props.navigate("/editEvent", {
      state: {
        action: "edit",
        eventId: this.state.eventId,
        eventPlanList: this.state.eventPlanList,
        regionList: this.state.regionList,
      },
    });

    // this.setState({
    //   action: "edit",
    //   render: true,
    // });
  }

  updateEventToBackend() {
    const postObject = {
      header: this.header,
      event: {
        id: this.state.eventId,
        name: this.state.eventName,
        eventType: this.state.eventType,
        approxAttendees: this.state.approxAttendees,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        registrationConfirmationText: this.state.registrationConfirmationText,
        isConnectToCvent: this.state.isConnectToCvent,
        code: this.state.ceventCode,
        cventDataCarryoverType: this.state.ceventCarryover,
        beforeTextcount: this.state.beforeTextcount,
        onTextcount: this.state.onTextcount,
        afterTextcount: this.state.afterTextcount,
        location: this.state.location,
        region: {
          name: this.state.region?.name,
          code: this.state.region?.code,
          isActive: this.state.region?.isActive,
          displaySequence: this.state.region?.displaySequence,
          description: this.state.region?.description,
          id: this.state.region?.id,
        },
        timezone: this.state.timeZone,
        // timezone: {
        //   id: this.state.timeZone?.id,
        // },
        // country: { id: this.state.country?.id },
        // state: { id: this.state.state?.id },
        eventPlan: {
          id: this.state.eventPlan?.id,
        },
      },
    };
    FetchServerData.callPostService("/eventms/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let eventDetails = output.data.event;
          PtsAlert.success(output.message);
          store.dispatch(SelectedDomainAction.setEventState(eventDetails));
          store.dispatch(SelectedDomainAction.setEventTimezone(eventDetails?.timezone));
          this.setState({
            action: "view",
            eventName: eventDetails.name,
            startDate: eventDetails.startDate,
            endDate: eventDetails.endDate,
            timeZone: eventDetails.timezone,
          });
          this.props.navigate("/eventMessages", {
            state: {
              // action: "view",
              eventId: this.state.eventId,
            },
          });
        } else {
        }
      }
    );
  }

  deleteEventToBackend() {
    const postObject = {
      header: this.header,
      event: {
        id: this.state.eventId,
      },
    };

    FetchServerData.callPostService("/eventms/delete", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/eventMgmt");
        } else {
        }
      })
      .catch((error) => { });
  }

  handleLocationChange(e) {
    this.setState({
      location: e.target.value,
    })
  }
  handleRegionChange(selectedRegion) {
    this.setState({
      region: selectedRegion,
      timeZoneListArray: selectedRegion?.timeZones,
      timeZone: null,
    });
  }
  handleCountryChange(selectedCountry) {
    this.setState({
      country: selectedCountry,
      state: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry?.id },
    };
    FetchServerData.callPostService("/countryms/get", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.setState({
            stateListArray: stateTimezoneList.states,
            timeZoneListArray: stateTimezoneList.timezones,
          });
        } else {
        }
      }
    );
  }

  handleStateChange(selectedState) {
    this.setState({ state: selectedState });
  }
  handleTimeZoneChange(selectedTimezone) {
    this.setState({
      timeZone: selectedTimezone,
    });
  }

  getDemoEventURLToBackend() {
    const postObject = {
      header: this.header,
      businessDomain: this.businessDomain,
    };
    FetchServerData.callPostService(
      "/calendleyms/getDemoEventUrl",
      postObject
    ).then((response) => {
      if (response.status === "SUCCESS") {
        let output = response.data;
        window.open(output.calendlyEventUrl);
      } else {
      }
    });
  }

  handleOpen() {
    this.setState({
      open: true,
    });
  }
  handleClose() {
    this.setState({
      open: false,
    });
  }

  validateDates = () => {
    const { startDate, endDate } = this.state;
    let isValid = true;

    if (!startDate) {
      this.setState({ errorMassage: true });
      isValid = false;
    }

    if (!endDate) {
      this.setState({ endDateErrorMassage: true });
      isValid = false;
    }

    if (startDate && endDate && endDate < startDate) {
      this.setState({ error: true });
      isValid = false;
    }

    return isValid;
  };

  handlePurchasePlanChange(e, plan) {
    e.preventDefault();

    if (160 < Utils.countLetters(this.state.registrationConfirmationText)) {
      this.setState({
        eventPurchasePlan: false,
      });
      return;
    }

    if (!this.validateDates()) return;

    const value = e.target.value;
    const modifiedData = [...this.state.eventPlanList];
    modifiedData.map((item) => {
      item.isChecked = item.id === +value;
      return item;
    });
    this.setState({
      eventPlanList: modifiedData,
      eventPlanId: value,
      // eventPlan: plan,
      eventPurchasePlan: true,
    });
  }

  sendEmailOpen() {
    this.setState({
      sendEmailOpen: true,
      requestedStartDate:
        this.state.requestedStartDate !== null
          ? this.state.requestedStartDate
          : this.state.startDate,
      requestedEndDate:
        this.state.requestedEndDate !== null
          ? this.state.requestedEndDate
          : this.state.endDate,
    });
  }
  handleSendEmailClose() {
    this.setState({ sendEmailOpen: false });
  }

  handleRequestStartDateChange(date) {
    let fromDate = Date.parse(date);
    let toDate = Date.parse(this.state.requestedEndDate);
    if (this.state.requestedEndDate === null && date === null) {
      this.setState({
        requestedStartDate: date,
        requestError: false,
        requestErrorMassage: false,
      });
    } else if (date === null) {
      this.setState({
        requestedStartDate: date,
        requestError: false,
        requestErrorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        requestedStartDate: date,
        requestError: true,
        requestErrorMassage: false,
      });
    } else {
      this.setState({
        requestedStartDate: date,
        requestError: false,
        requestErrorMassage: false,
      });
    }
  }

  handleRequestEndDateChange(date) {
    let fromDate = Date.parse(this.state.requestedStartDate);
    let toDate = Date.parse(date);

    if (this.state.requestedStartDate === null && date === null) {
      this.setState({
        requestedEndDate: date,
        requestError: false,
        requestErrorMassage: false,
      });
    } else if (this.state.startDate === null) {
      this.setState({
        requestedEndDate: date,
        requestError: false,
        requestErrorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        requestedEndDate: date,
        requestError: true,
        requestErrorMassage: false,
      });
    } else {
      this.setState({
        requestedEndDate: date,
        requestError: false,
        requestErrorMassage: false,
      });
    }
  }

  requestDateChange() {
    const postObject1 = {
      header: this.header,
      event: {
        requestedStartDate: this.state.requestedStartDate,
        requestedEndDate: this.state.requestedEndDate,
        id: this.state.eventId,
      },
    };
    FetchServerData.callPostService(
      "/eventms/requestDateChange",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let eventDetails = output.data.event;
        PtsAlert.success(output.message);
        this.setState({
          sendEmailOpen: false,
          isDatechangeRequested: eventDetails?.isDatechangeRequested,
          requestedStartDate: eventDetails?.requestedStartDate,
          requestedEndDate: eventDetails?.requestedEndDate,
        });
      } else {
      }
    });
  }

  approveDateChangeToBackend() {
    const postObject = {
      header: this.header,
      event: {
        id: this.state.eventId,
      },
    };
    FetchServerData.callPostService(
      "/eventms/approveDateChange",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let eventDateChangeDetails = output.data.event;
        store.dispatch(
          SelectedDomainAction.setEventState(eventDateChangeDetails)
        );
        store.dispatch(SelectedDomainAction.setEventTimezone(eventDateChangeDetails?.timezone));
        this.setState({
          isDatechangeRequested: eventDateChangeDetails.isDatechangeRequested,
          startDate: eventDateChangeDetails.startDate,
          endDate: eventDateChangeDetails.endDate,
        });
      } else {
      }
    });
  }
  rejectDateChangeToBackend() {
    const postObject = {
      header: this.header,
      event: {
        id: this.state.eventId,
      },
    };
    FetchServerData.callPostService(
      "/eventms/rejectDateChange",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let eventDateChangeDetails = output.data.event;
        store.dispatch(
          SelectedDomainAction.setEventState(eventDateChangeDetails)
        );
        store.dispatch(SelectedDomainAction.setEventTimezone(eventDateChangeDetails?.timezone));
        PtsAlert.success(output.message);
        this.setState({
          isDatechangeRequested: eventDateChangeDetails.isDatechangeRequested,
        });
      } else {
      }
    });
  }
  // nextPurchseEventPlan() {
  //   if (Utils.equalsIgnoreCase(this.planType, "Onetime")) {
  //     this.setState({
  //       action: "PurchasePlan",
  //       eventPlanId: this.state.eventPlan?.id,
  //       eventId: this.state?.id,
  //     });
  //   } else {
  //     this.props.navigate("/eventMgmt");
  //   }
  // }

  onSuccessPayment() {
    this.props.navigate("/eventBillingInfo", {
      state: {
        pageId: "EventBilling",
      },
    });
    this.setState({
      render: true,
    });
  }


  ptsDateFormat(dateTime) {
    if (!dateTime) return "";
    return moment.utc(dateTime).local().format("MMM DD, YYYY");
  };

  render() {
    this.textareaRef = React.createRef();
    if (this.state.action === "create") {
      return this.createEvent();
    } else if (this.state.action === "edit") {
      return this.editEvent();
    } else if (this.state.action === "view") {
      return this.viewEvent();
    } else if (this.state.action === "PurchasePlan") {
      return (
        <PurchaseEventPlan
          eventId={this.state.eventId}
          eventPlanId={this.state.eventPlanId}
          pageId="PurchasePlan"
        />
      );
    }
  }

  createEvent() {
    const recommendedPlan = this.getRecommendedPlan();

    return (
      <>
        {!this.state.eventPurchasePlan ? (
          <>
            <MenuWithBreadScrum
              breadCrumb={this.breadCrumb}
              navigate={this.props.navigate}
              domainObject="Event"
              name="Create Event"
            />

            <div className="row">
              {Utils.equalsIgnoreCase(this.planType, "Onetime") ? (
                <>
                  <ValidatorForm
                    className="text-start"
                    ref="form"
                    onSubmit={this.handlePurchasePlanChange.bind(this)}
                  >
                    <>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="card " id="giveBeeCard">
                            <div
                              className="card-header d-flex align-items-center justify-content-between p-4"
                              id="assetCardHeader"
                            >
                              <span
                                className="fw-bold"
                                style={{ color: "#06669a", fontSize: "18px" }}
                              >
                                Step 1: Enter event details
                              </span>
                            </div>
                            <div className="card-body">
                              <div className="row d-flex">
                                <div className="col-md-6"
                                  style={{
                                    borderRight: "1px solid #d3d3d3",
                                    paddingRight: "25px",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="MuiAutocomplete-label form-label mb-1"
                                        htmlFor="collapsible-firstname"
                                      >
                                        Event Name*
                                      </label>
                                      <input
                                        title=""
                                        required
                                        autoFocus={true}
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.eventName}
                                        onChange={this.handleEventNameChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                      />
                                    </div>
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="MuiAutocomplete-label form-label "
                                        htmlFor="collapsible-firstname"
                                      >
                                        Event Type*
                                      </label>

                                      <Autocomplete
                                        title=""
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.eventTypeList}
                                        value={this.state.eventType}
                                        getOptionLabel={(option) => option.type}
                                        defaultValue={this.state.eventType}
                                        onChange={(event, value) => {
                                          this.handleEventTypeChange(value);
                                        }}
                                        inputprops={{
                                          style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            required
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-sm-12">
                                      <label className="form-label" htmlFor="multiStepsEmail">
                                        Event Location (City, State, Country)*
                                      </label>
                                      <input
                                        autoComplete="off"
                                        type="text"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        onChange={this.handleLocationChange.bind(this)}
                                        value={this.state.location}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="MuiAutocomplete-label form-label"
                                        htmlFor="collapsible-fullname"
                                      >
                                        Event Region
                                      </label>
                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.state.regionList}
                                        value={this.state.region}
                                        defaultValue={this.state.select}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                          this.handleRegionChange(value);
                                        }}
                                        inputprops={{
                                          style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label
                                        className="MuiAutocomplete-label form-label"
                                        htmlFor="multiStepsEmail"
                                      >
                                        Event Timezone*
                                      </label>
                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.state.timeZoneListArray}
                                        value={this.state.timeZone}
                                        getOptionLabel={(option) =>
                                          option.displayText
                                        }
                                        defaultValue={this.state.timeZone}
                                        onChange={(event, value) => {
                                          this.handleTimeZoneChange(value);
                                        }}
                                        inputprops={{
                                          style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            title=""
                                            required
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3 datePickerHelperText">
                                    <div className="col-md-6">
                                      <div className="row">
                                        <div className="col-md-12" id="assetFormLabel">
                                          <label
                                            className="form-label MuiAutocomplete-label"
                                            htmlFor="collapsible-email"
                                          >
                                            Start Date*
                                            <span
                                              className="ms-1"
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              (Texting First Day)
                                            </span>
                                          </label>

                                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <ThemeProvider theme={materialTheme}>
                                              <DatePicker
                                                value={this.state.startDate}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                inputVariant="outlined"
                                                // timeinputlabel="Time:"
                                                minDate={subDays(new Date(), 0)}
                                                format="MM/dd/yyyy"
                                                style={{ background: "#fff" }}
                                                onChange={this.handleStartDateChange.bind(
                                                  this
                                                )}
                                                helperText={
                                                  this.state.errorMassage
                                                    ? "Start Date is Required"
                                                    : ""
                                                }
                                                error={this.state.errorMassage}
                                                InputProps={{
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <IconButton>
                                                        <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                      </IconButton>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </ThemeProvider>
                                          </MuiPickersUtilsProvider>
                                        </div>
                                      </div>
                                      <div className="row mt-3">
                                        <div className="col-md-12" id="assetFormLabel">
                                          <label
                                            className="form-label MuiAutocomplete-label"
                                            htmlFor="collapsible-jotitle"
                                          >
                                            End Date*
                                            <span
                                              className="ms-1"
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              (Texting Last Day)
                                            </span>
                                          </label>
                                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <ThemeProvider theme={materialTheme}>
                                              <DatePicker
                                                value={this.state.endDate}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                inputVariant="outlined"
                                                minDate={subDays(new Date(), 0)}
                                                format="MM/dd/yyyy"
                                                style={{ background: "#fff" }}
                                                onChange={this.handleEndDateChange.bind(
                                                  this
                                                )}
                                                helperText={
                                                  this.state.endDateErrorMassage
                                                    ? "End Date is Required"
                                                    : ""
                                                }
                                                error={this.state.endDateErrorMassage}
                                                InputProps={{
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <IconButton>
                                                        <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                      </IconButton>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </ThemeProvider>
                                          </MuiPickersUtilsProvider>
                                          {this.state.error ? (
                                            <lable className="errorMassageShow">
                                              End Date should be after Start Date
                                            </lable>
                                          ) : (
                                            ""
                                          )}

                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="noteBox mt-4">
                                        <strong>NOTE:</strong> This account can only send texts to mobile numbers with country code +1.
                                        If you require a plan that offers support for numbers outside of the USA/Canada,
                                        please contact:
                                        <a
                                          className="ms-1 fw-bold"
                                          href={`mailto: support@givbee.com`}
                                          rel="noopener noreferrer"
                                          style={{ color: "#ffff" }}
                                        >
                                          <u>support@givbee.com.</u>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6"
                                  style={{
                                    borderLeft: "1px solid #d3d3d3",
                                    paddingLeft: "25px",
                                  }}>
                                  <div className="row">
                                    <div className="col-md-12" id="assetFormLabel">
                                      <span
                                        className="fw-bold"
                                        style={{ color: "#06669a", fontSize: "18px" }}
                                      >
                                        Cvent settings - <span style={{ color: "#353538", fontSize: "12px" }}>Complete this section to use GivBee's webhook integration.</span>
                                      </span>
                                      <br></br>
                                      <span style={{ color: "#353538", fontSize: "12px" }}>Leave this section empty if you do not have the details or have not yet decided.</span>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="form-label"
                                        htmlFor="collapsible-firstname"
                                        style={{ marginBottom: "0.15rem" }}
                                      >
                                        Cvent Event Code
                                      </label>
                                      <input
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.ceventCode}
                                        onChange={this.handleCeventCodeChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="MuiAutocomplete-label form-label "
                                        htmlFor="collapsible-firstname"
                                        style={{ paddingBottom: "2px" }}
                                      >
                                        Cvent data carry over
                                      </label>

                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.cventDataCarryoverTypes}
                                        value={this.state.ceventCarryover}
                                        getOptionLabel={(option) => option.type}
                                        defaultValue={this.state.ceventCarryover}
                                        onChange={(event, value) => {
                                          this.handleCeventCarryoverChange(value);
                                        }}
                                        inputprops={{
                                          style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-12" id="assetFormLabel">
                                      <label
                                        className="form-label "
                                        htmlFor="collapsible-firstname"
                                      >
                                        Want to send a text confirmation
                                        with each Cvent registration? Enter it here:
                                      </label>
                                      <textarea
                                        ref={this.textareaRef}
                                        value={
                                          this.state.registrationConfirmationText
                                        }
                                        onChange={this.handleRegistrationConfirmationTextChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        // rows="3"
                                        style={{
                                          overflow: "hidden",
                                          resize: "vertical",
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          float: "right",
                                        }}
                                      >
                                        {Utils.trimLetters(this.state.registrationConfirmationText ?? "")}/{160 ?? 0}
                                      </span>
                                      <br></br>
                                      {160 <
                                        Utils.countLetters(this.state.registrationConfirmationText) && (
                                          <span
                                            className="danger ms-1"
                                            style={{ color: "red", fontSize: "14px" }}
                                          >
                                            Your message is limited to 160 characters.
                                          </span>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-md-6">
                          <div className="card " id="giveBeeCard">
                            <div
                              className="card-header d-flex align-items-center justify-content-between p-4"
                              id="assetCardHeader"
                            >
                              <span
                                className="fw-bold"
                                style={{ color: "#06669a", fontSize: "18px" }}
                              >
                                Step 2: Calculate text credits needed
                              </span>
                            </div>
                            <div className="card-body">
                              <div className="row d-flex">
                                <div
                                  className="col-md-5 align-self-center"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Attendee count (approx):
                                  </label>
                                </div>
                                <div className="col-md-2" id="assetFormLabel">
                                  <input
                                    title=""
                                    required
                                    type="number"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    style={{ height: "36px" }}
                                    value={this.state.approxAttendees}
                                    onChange={this.handleApproxAttendeeseChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-4 d-flex">
                                <div
                                  className="col-md-5 align-self-center"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Pre-event texts:
                                  </label>
                                </div>
                                <div className="col-md-2" id="assetFormLabel">
                                  <input
                                    type="number"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    style={{ height: "35px" }}
                                    value={this.state.beforeTextcount}
                                    onChange={this.handleBeforeTextcountChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-4 d-flex">
                                <div
                                  className="col-md-5 align-self-center"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    During-event texts:
                                  </label>
                                </div>
                                <div className="col-md-2" id="assetFormLabel">
                                  <input
                                    type="number"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    style={{ height: "35px" }}
                                    value={this.state.onTextcount}
                                    onChange={this.handleOnTextcountChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-4 d-flex">
                                <div
                                  className="col-md-5 align-self-center"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Post-event texts:
                                  </label>
                                </div>
                                <div className="col-md-2" id="assetFormLabel">
                                  <input
                                    type="number"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    style={{ height: "35px" }}
                                    value={this.state.afterTextcount}
                                    onChange={this.handleAfterTextcountChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-4 d-flex">
                                <div
                                  className="col-md-5 align-self-center"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Estimated text credits required:
                                  </label>
                                </div>
                                <div className="col-md-2 text-center fw-bold" id="assetFormLabel">
                                  {(
                                    Number(this.state.approxAttendees || 0) *
                                    (Number(this.state.beforeTextcount || 0) +
                                      Number(this.state.onTextcount || 0) +
                                      Number(this.state.afterTextcount || 0))
                                  ).toLocaleString()}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div >
                      </div>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div
                            className="card"
                            // id="giveBeeCard"
                            style={{
                              padding: "1em",
                              backgroundColor: "#fff",
                              position: "relative",
                              height: "100%",
                              boxShadow:
                                "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgb(0 0 0 / 29%), 0 3px 1px -2px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            <div
                              className="card-header d-flex align-items-center justify-content-between p-4 pb-3"
                              id="assetCardHeader"
                            >
                              <div className="col-md-12" id="assetFormLabel">
                                <span
                                  className="fw-bold"
                                  style={{ color: "#06669a", fontSize: "18px" }}
                                >
                                  Step 3: Purchase Plan
                                </span>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row d-flex align-item-stretch">
                                    {this.state.eventPlanList?.map(
                                      (plan, index) =>
                                        plan?.planType?.type === "Onetime" && (
                                          <>
                                            <div className="col-md-3">
                                              <div className="row text-center justify-content-center">
                                                <div className="col-md-10 align-self-center mb-2 blink_me">
                                                  {recommendedPlan?.smsCredits ===
                                                    plan.smsCredits ? (
                                                    <span
                                                      style={{
                                                        backgroundColor: "green",
                                                        color: "#fff",
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                        padding: "5px 20px",
                                                        borderRadius: "20px",
                                                      }}
                                                    >
                                                      RECOMMENDED
                                                    </span>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        fontSize: "16px",
                                                        padding: "5px 20px",
                                                        borderRadius: "20px",
                                                      }}
                                                    ></span>
                                                  )}
                                                </div>
                                              </div>
                                              <div
                                                className="row d-flex"
                                              // style={{
                                              //   height: "100%",
                                              // }}
                                              >
                                                <div className="col-md-12">
                                                  <div
                                                    className="box"
                                                    data-aos="zoom-in"
                                                    data-aos-delay={100}
                                                    style={{
                                                      padding: "0em",
                                                      position: "relative",
                                                      height: "100%",
                                                    }}
                                                    id="regPlanBox"
                                                  >
                                                    <div
                                                      className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                      style={
                                                        recommendedPlan?.smsCredits ===
                                                          plan.smsCredits
                                                          ? {
                                                            height: "100%",
                                                          }
                                                          : {
                                                            height: "100%",
                                                            boxShadow: "none",
                                                          }
                                                      }
                                                    >
                                                      <div
                                                        class="entry-title plan_card"
                                                        style={{
                                                          background:
                                                            plan.colorSecondary,
                                                        }}
                                                      >
                                                        <h3
                                                          class="plan_card"
                                                          style={{
                                                            padding: "7px",
                                                            color: "#fff",
                                                            background:
                                                              plan.colorPrimary,
                                                          }}
                                                        >
                                                          {plan.name}
                                                        </h3>
                                                        <div
                                                          class="price"
                                                          style={{
                                                            background:
                                                              plan.colorPrimary,
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              left: "20px",
                                                            }}
                                                          >
                                                            {`$${Utils.formatWithCommas(
                                                              plan.price
                                                            )}`}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="entry-content flex-grow-1 d-flex flex-column">
                                                        <ul className="flex-grow-1">
                                                          {plan?.planItems.map(
                                                            (planItem, index) => (
                                                              <li
                                                                style={{
                                                                  padding:
                                                                    "0.2em",
                                                                  fontWeight:
                                                                    planItem?.isFontBold &&
                                                                    "600",
                                                                  fontStyle:
                                                                    planItem?.isFontItalic &&
                                                                    "italic",
                                                                  fontSize:
                                                                    planItem?.isFontSmall &&
                                                                    "12px",
                                                                }}
                                                              >
                                                                {planItem.name}
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                        <div className="row p-3">
                                                          <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                            <div className="btn_plan1">
                                                              <Button
                                                                type="submit"
                                                                variant="contained"
                                                                style={{
                                                                  borderRadius:
                                                                    "10px",
                                                                  backgroundColor:
                                                                    plan.colorPrimary,
                                                                  color: "#fff",
                                                                  marginRight:
                                                                    "1rem",
                                                                  fontWeight:
                                                                    "bold",
                                                                  padding:
                                                                    "3px 20px",
                                                                  textTransform:
                                                                    "capitalize",
                                                                }}
                                                                key={plan.id}
                                                                onClick={() =>
                                                                  this.setState({
                                                                    eventPlan:
                                                                      plan,
                                                                  })
                                                                }
                                                              >
                                                                Purchase
                                                              </Button>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* <div className="row mt-2 text-center">
                                            <div className="col-md-12 align-self-center">
                                              <FormControlLabel
                                                style={{
                                                  color: "#000",
                                                  margin: "0",
                                                  padding: "0",
                                                  height: "15px",
                                                }}
                                                control={
                                                  <Radio
                                                    variant="outlined"
                                                    id="isAsset"
                                                    value={plan.id}
                                                    checked={plan.isChecked}
                                                    onChange={(e) =>
                                                      this.handlePurchasePlanChange(
                                                        e,
                                                        plan
                                                      )
                                                    }
                                                    style={{
                                                      background: "none",
                                                    }}
                                                  />
                                                }
                                                label="Choose plan"
                                                labelPlacement="end"
                                              />
                                            </div>
                                          </div> */}
                                            </div>
                                          </>
                                        )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row d-flex align-items-center justify-content-between">
                        <div className="col-sm-12 mt-3 text-center">
                          {/* <Button
                        type="submit"
                        variant="contained"
                        style={{
                          background: "#37517e",
                          color: "#fff",
                          marginRight: "1rem",
                          fontWeight: "bold",
                          padding: "3px 20px",
                          textTransform: "capitalize",
                        }}
                      >
                        Next <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i>
                      </Button>
                      &nbsp;&nbsp; */}
                          <CancelIconButton
                            onClick={(e) => this.createCancel()}
                          />
                        </div>
                      </div>
                    </>
                  </ValidatorForm >
                </>
              ) : (
                <>
                  <ValidatorForm
                    className="text-start"
                    ref="form"
                    onSubmit={this.createSubscriptionEventToBackend.bind(this)}
                  >
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card " id="giveBeeCard">
                          <div
                            className="card-header d-flex align-items-center justify-content-between p-4"
                            id="assetCardHeader"
                          >
                            <span
                              className="fw-bold"
                              style={{ color: "#06669a", fontSize: "18px" }}
                            >
                              Step 1: Enter event details
                            </span>
                          </div>
                          <div className="card-body">
                            <div className="row d-flex">
                              <div className="col-md-6"
                                style={{
                                  borderRight: "1px solid #d3d3d3",
                                  paddingRight: "25px",
                                }}
                              >
                                <div className="row">
                                  <div className="col-md-6" id="assetFormLabel">
                                    <label
                                      className="MuiAutocomplete-label form-label mb-1"
                                      htmlFor="collapsible-firstname"
                                    >
                                      Event Name*
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoFocus={true}
                                      type="text"
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.eventName}
                                      onChange={this.handleEventNameChange.bind(
                                        this
                                      )}
                                      validators={["required"]}
                                      errormessages={["This field is required"]}
                                    />
                                  </div>
                                  <div className="col-md-6" id="assetFormLabel">
                                    <label
                                      className="MuiAutocomplete-label form-label "
                                      htmlFor="collapsible-firstname"
                                    >
                                      Event Type*
                                    </label>

                                    <Autocomplete
                                      title=""
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.eventTypeList}
                                      value={this.state.eventType}
                                      getOptionLabel={(option) => option.type}
                                      defaultValue={this.state.eventType}
                                      onChange={(event, value) => {
                                        this.handleEventTypeChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          required
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="autoComplete"
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-sm-12">
                                    <label className="form-label" htmlFor="multiStepsEmail">
                                      Event Location (City, State, Country)*
                                    </label>
                                    <input
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      onChange={this.handleLocationChange.bind(this)}
                                      value={this.state.location}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-6" id="assetFormLabel">
                                    <label
                                      className="MuiAutocomplete-label form-label"
                                      htmlFor="collapsible-fullname"
                                    >
                                      Event Region
                                    </label>
                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.state.regionList}
                                      value={this.state.region}
                                      defaultValue={this.state.select}
                                      getOptionLabel={(option) => option.name}
                                      onChange={(event, value) => {
                                        this.handleRegionChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="autoComplete"
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label
                                      className="MuiAutocomplete-label form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Event Timezone*
                                    </label>
                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.state.timeZoneListArray}
                                      value={this.state.timeZone}
                                      getOptionLabel={(option) =>
                                        option.displayText
                                      }
                                      defaultValue={this.state.timeZone}
                                      onChange={(event, value) => {
                                        this.handleTimeZoneChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          title=""
                                          required
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="autoComplete"
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3 datePickerHelperText">
                                  <div className="col-md-6">
                                    <div className="row">
                                      <div className="col-md-12" id="assetFormLabel">
                                        <label
                                          className="form-label MuiAutocomplete-label"
                                          htmlFor="collapsible-email"
                                        >
                                          Start Date*
                                          <span
                                            className="ms-1"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            (Texting First Day)
                                          </span>
                                        </label>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <ThemeProvider theme={materialTheme}>
                                            <DatePicker
                                              value={this.state.startDate}
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              inputVariant="outlined"
                                              // timeinputlabel="Time:"
                                              minDate={subDays(new Date(), 0)}
                                              format="MM/dd/yyyy"
                                              style={{ background: "#fff" }}
                                              onChange={this.handleStartDateChange.bind(
                                                this
                                              )}
                                              helperText={
                                                this.state.errorMassage
                                                  ? "Start Date is Required"
                                                  : ""
                                              }
                                              error={this.state.errorMassage}
                                              InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton>
                                                      <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col-md-12" id="assetFormLabel">
                                        <label
                                          className="form-label MuiAutocomplete-label"
                                          htmlFor="collapsible-jotitle"
                                        >
                                          End Date*
                                          <span
                                            className="ms-1"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            (Texting Last Day)
                                          </span>
                                        </label>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <ThemeProvider theme={materialTheme}>
                                            <DatePicker
                                              value={this.state.endDate}
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              inputVariant="outlined"
                                              minDate={subDays(new Date(), 0)}
                                              format="MM/dd/yyyy"
                                              style={{ background: "#fff" }}
                                              onChange={this.handleEndDateChange.bind(
                                                this
                                              )}
                                              helperText={
                                                this.state.endDateErrorMassage
                                                  ? "End Date is Required"
                                                  : ""
                                              }
                                              error={this.state.endDateErrorMassage}
                                              InputProps={{
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton>
                                                      <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                        {this.state.error ? (
                                          <lable className="errorMassageShow">
                                            End Date should be after Start Date
                                          </lable>
                                        ) : (
                                          ""
                                        )}

                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="noteBox mt-4">
                                      <strong>NOTE:</strong> This account can only send texts to mobile numbers with country code +1.
                                      If you require a plan that offers support for numbers outside of the USA/Canada,
                                      please contact:
                                      <a
                                        className="ms-1 fw-bold"
                                        href={`mailto: support@givbee.com`}
                                        rel="noopener noreferrer"
                                        style={{ color: "#ffff" }}
                                      >
                                        <u>support@givbee.com.</u>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6"
                                style={{
                                  borderLeft: "1px solid #d3d3d3",
                                  paddingLeft: "25px",
                                }}>
                                <div className="row">
                                  <div className="col-md-12" id="assetFormLabel">
                                    <span
                                      className="fw-bold"
                                      style={{ color: "#06669a", fontSize: "18px" }}
                                    >
                                      Cvent settings - <span style={{ color: "#353538", fontSize: "12px" }}>Complete this section to use GivBee's webhook integration.</span>
                                    </span>
                                    <br></br>
                                    <span style={{ color: "#353538", fontSize: "12px" }}>Leave this section empty if you do not have the details or have not yet decided.</span>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-6" id="assetFormLabel">
                                    <label
                                      className="form-label"
                                      htmlFor="collapsible-firstname"
                                      style={{ marginBottom: "0.15rem" }}
                                    >
                                      Cvent Event Code
                                    </label>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.ceventCode}
                                      onChange={this.handleCeventCodeChange.bind(
                                        this
                                      )}
                                      validators={["required"]}
                                      errormessages={["This field is required"]}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-6" id="assetFormLabel">
                                    <label
                                      className="MuiAutocomplete-label form-label "
                                      htmlFor="collapsible-firstname"
                                      style={{ paddingBottom: "2px" }}
                                    >
                                      Cvent data carry over
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.cventDataCarryoverTypes}
                                      value={this.state.ceventCarryover}
                                      getOptionLabel={(option) => option.type}
                                      defaultValue={this.state.ceventCarryover}
                                      onChange={(event, value) => {
                                        this.handleCeventCarryoverChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="autoComplete"
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-12" id="assetFormLabel">
                                    <label
                                      className="form-label "
                                      htmlFor="collapsible-firstname"
                                    >
                                      Want to send a text confirmation
                                      with each Cvent registration? Enter it here:
                                    </label>
                                    <textarea
                                      ref={this.textareaRef}
                                      value={
                                        this.state.registrationConfirmationText
                                      }
                                      onChange={this.handleRegistrationConfirmationTextChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="exampleFormControlTextarea1"
                                      // rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {Utils.trimLetters(this.state.registrationConfirmationText ?? "")}/{160 ?? 0}
                                    </span>
                                    <br></br>
                                    {160 <
                                      Utils.countLetters(this.state.registrationConfirmationText) && (
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}
                                        >
                                          Your message is limited to 160 characters.
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row d-flex align-items-center justify-content-between">
                      <div className="col-sm-12 mt-3 text-center">
                        <SaveButton btnName="Create" type="submit" />
                        &nbsp;&nbsp;
                        <CancelIconButton
                          onClick={(e) => this.createCancel()}
                        />
                      </div>
                    </div>
                  </ValidatorForm >
                </>
              )
              }
            </div>
          </>
        ) : (
          <>
            <MenuWithBreadScrum
              breadCrumb={this.breadCrumb}
              key={this.state.eventPurchasePlan}
              navigate={this.props.navigate}
              backCallback={this.viewCancel.bind(this)}
              domainObject="Event"
              name="Purchase Event"
            />
            <div className="row">
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                }}
              >
                <div className="col-md-12">
                  <div className="card " id="giveBeeCard">
                    <div className="card-body">
                      <div class="container">
                        <div class="row  justify-content-around">
                          <div className="col-md-4 align-self-center">
                            <div className="row d-flex align-item-stretch justify-content-center">
                              <div className="col-md-9 mt-4">
                                <div
                                  className="row d-flex"
                                  style={{
                                    height: "100%",
                                  }}
                                >
                                  <div className="col-md-12">
                                    <div
                                      className="box"
                                      data-aos="zoom-in"
                                      data-aos-delay={100}
                                      style={{
                                        padding: "0em",
                                        position: "relative",
                                        height: "100%",
                                      }}
                                      id="regPlanBox"
                                    >
                                      <div
                                        class="regplan-inner plan_card plan_card_bottom"
                                        style={{
                                          height: "100%",
                                        }}
                                      >
                                        <div
                                          class="entry-title plan_card"
                                          style={{
                                            background:
                                              this.state.eventPlan
                                                ?.colorSecondary,
                                          }}
                                        >
                                          <h3
                                            class="plan_card"
                                            style={{
                                              padding: "7px",
                                              color: "#fff",
                                              background:
                                                this.state.eventPlan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            {this.state.eventPlan?.name}
                                          </h3>
                                          <div
                                            class="price"
                                            style={{
                                              background:
                                                this.state.eventPlan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            <span
                                              style={{
                                                left: "20px",
                                              }}
                                            >
                                              {`$${Utils.formatWithCommas(
                                                this.state.eventPlan?.price
                                              )}`}
                                            </span>
                                          </div>
                                        </div>
                                        <div class="entry-content mb-4">
                                          <ul>
                                            {this.state.eventPlan?.planItems.map(
                                              (planItem, index) => (
                                                <li
                                                  style={{
                                                    padding: "0.2em",
                                                    fontWeight:
                                                      planItem?.isFontBold &&
                                                      "600",
                                                    fontStyle:
                                                      planItem?.isFontItalic &&
                                                      "italic",
                                                    fontSize:
                                                      planItem?.isFontSmall &&
                                                      "12px",
                                                  }}
                                                >
                                                  {planItem.name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <Elements stripe={stripePromise}>
                              <ElementsConsumer>
                                {({ stripe, elements }) => (
                                  <EventCreditCardForm
                                    stripe={stripe}
                                    elements={elements}
                                    eventplan={this.state.eventPlan}
                                    onCreateEvent={this.createEventToBackend.bind(
                                      this
                                    )}
                                    action="list"
                                    subscriptionId={this.state.subscriptionId}
                                    pageId={this.state.pageId}
                                    processing={this.state.processing}
                                    error={this.state.cardError}
                                  />
                                )}
                              </ElementsConsumer>
                            </Elements>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
        }
      </>
    );
  }

  editEvent() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <div className="mt-4" style={{ maxWidth: "100%" }}>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            // deleteCallback={this.deleteEventToBackend.bind(this)}
            // getDeletePermission={this.state.getDeletePermission}
            domainObject={this.state.eventName}
            name="Edit event settings"
          />
          <div className="row">
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.updateEventToBackend.bind(this)}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="card " id="giveBeeCard">
                    <div className="row d-flex">
                      <div className="col-md-12">
                        {/* <div
                          className="card-header d-flex align-items-center justify-content-between p-4"
                          id="assetCardHeader"
                        >
                          <div className="col-md-12">
                            <span
                              className="fw-bold"
                              style={{ color: "#06669a", fontSize: "18px" }}
                            >
                              Step 1: Please provide basic details about your event.
                            </span>
                          </div>
                        </div> */}
                        {/* <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-firstname"
                                    style={{ marginBottom: "0.15rem" }}
                                  >
                                    Event Name*
                                  </label>
                                  <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.eventName}
                                    onChange={this.handleEventNameChange.bind(this)}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label "
                                    htmlFor="collapsible-firstname"
                                  >
                                    Event Type*
                                  </label>

                                  <Autocomplete
                                    title=""
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.eventTypeList}
                                    value={this.state.eventType}
                                    getOptionLabel={(option) => option.type}
                                    defaultValue={this.state.eventType}
                                    onChange={(event, value) => {
                                      this.handleEventTypeChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3 datePickerHelperText">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label MuiAutocomplete-label"
                                    htmlFor="collapsible-email"
                                  >
                                    Start Date*
                                    <span
                                      className="ms-1"
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      (Texting First Day)
                                    </span>
                                  </label>
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <ThemeProvider theme={materialTheme}>
                                      <DatePicker
                                        disabled
                                        value={this.state.startDate}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        inputVariant="outlined"
                                        // timeinputlabel="Time:"
                                        minDate={subDays(new Date(), 0)}
                                        format="MM/dd/yyyy"
                                        style={{ background: "#fff" }}
                                        onChange={this.handleStartDateChange.bind(
                                          this
                                        )}
                                        helperText={
                                          this.state.errorMassage
                                            ? "Start Date is Required"
                                            : ""
                                        }
                                        error={this.state.errorMassage}
                                        InputProps={{
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <IconButton>
                                                <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </ThemeProvider>
                                  </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label MuiAutocomplete-label"
                                    htmlFor="collapsible-email"
                                  >
                                    End Date*
                                    <span
                                      className="ms-1"
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      (Texting end from this day)
                                    </span>
                                  </label>
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <ThemeProvider theme={materialTheme}>
                                      <DatePicker
                                        disabled
                                        value={this.state.endDate}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        inputVariant="outlined"
                                        minDate={subDays(new Date(), 0)}
                                        format="MM/dd/yyyy"
                                        style={{ background: "#fff" }}
                                        onChange={this.handleEndDateChange.bind(
                                          this
                                        )}
                                        helperText={
                                          this.state.endDateErrorMassage
                                            ? "End Date is Required"
                                            : ""
                                        }
                                        error={this.state.endDateErrorMassage}
                                        InputProps={{
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <IconButton>
                                                <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </ThemeProvider>
                                  </MuiPickersUtilsProvider>
                                  {this.state.error ? (
                                    <lable className="errorMassageShow">
                                      End Date should be after Start Date
                                    </lable>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              {this.state.isDatechangeRequested && (
                                <>
                                  {this.header?.isAp ? (
                                    <div className="row mt-3 datePickerHelperText">
                                      <div
                                        className="col-md-6 align-self-center"
                                        id="assetFormLabel"
                                      >
                                        <div className="row">
                                          <label
                                            className="col-sm-5 form-label pe-0"
                                            htmlFor="collapsible-email"
                                          >
                                            New Start Date
                                          </label>
                                          <div className="col-sm-7 MuiInputBase-root">
                                            {Utils.ptsDateFormat(
                                              this.state.requestedStartDate
                                            )}
                                          </div>
                                        </div>
                                        <div className="row">
                                          <label
                                            className="col-sm-5 form-label pe-0"
                                            htmlFor="collapsible-jotitle"
                                          >
                                            New End Date
                                          </label>
                                          <div className="col-sm-7 MuiInputBase-root">
                                            {Utils.ptsDateFormat(
                                              this.state.requestedEndDate
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="col-md-6 align-self-center"
                                        id="assetFormLabel"
                                      >
                                        <div className="row">
                                          <div className="col-sm-12">
                                            <Button
                                              type="button"
                                              variant="contained"
                                              id="ptsButton"
                                              style={{
                                                background: "green",
                                                color: "#fff",
                                                marginRight: "1rem",
                                                fontWeight: "bold",
                                                textTransform: "capitalize",
                                                padding: "2px 10px",
                                                "&:hover": {
                                                  backgroundColor: "#1a3a5c", // Darker shade on hover
                                                },
                                              }}
                                              onClick={this.approveDateChangeToBackend.bind(
                                                this
                                              )}
                                            >
                                              Approve
                                            </Button>
                                            <Button
                                              type="button"
                                              variant="contained"
                                              id="ptsButton"
                                              // startIcon={<CloseIcon />}
                                              onClick={this.rejectDateChangeToBackend.bind(
                                                this
                                              )}
                                            >
                                              Deny
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="row mt-3 datePickerHelperText">
                                      <span style={{ color: "red" }}>
                                        Date Change Requested.
                                      </span>
                                    </div>
                                  )}
                                </>
                              )}
                              <div className="row mt-3">
                                <div className="col-sm-12">
                                  <label className="form-label" htmlFor="multiStepsEmail">
                                    City
                                  </label>
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    onChange={this.handleLocationChange.bind(this)}
                                    value={this.state.location}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="collapsible-fullname"
                                  >
                                    Country
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.countryListArray}
                                    value={this.state.country}
                                    defaultValue={this.state.select}
                                    getOptionLabel={(option) => option.namecode}
                                    onChange={(event, value) => {
                                      this.handleCountryChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="multiStepsState"
                                  >
                                    State
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    disabled={this.state.country === null}
                                    options={this.state.stateListArray}
                                    value={this.state.state}
                                    getOptionLabel={(option) => option.namecode}
                                    defaultValue={this.state.state}
                                    onChange={(event, value) => {
                                      this.handleStateChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="multiStepsEmail"
                                  >
                                    Timezone*
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.timeZoneListArray}
                                    value={this.state.timeZone}
                                    getOptionLabel={(option) =>
                                      option.name + " (" + option.abbreviation + ")"
                                    }
                                    defaultValue={this.state.timeZone}
                                    onChange={(event, value) => {
                                      this.handleTimeZoneChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        title=""
                                        required
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="card-body">
                          <div className="row d-flex">
                            <div className="col-md-6"
                              style={{
                                borderRight: "1px solid #d3d3d3",
                                paddingRight: "25px",
                              }}
                            >
                              <div className="row">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label mb-1"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Event Name*
                                  </label>
                                  <input
                                    title=""
                                    required
                                    autoFocus={true}
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.eventName}
                                    onChange={this.handleEventNameChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label "
                                    htmlFor="collapsible-firstname"
                                  >
                                    Event Type*
                                  </label>

                                  <Autocomplete
                                    title=""
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.eventTypeList}
                                    value={this.state.eventType}
                                    getOptionLabel={(option) => option.type}
                                    defaultValue={this.state.eventType}
                                    onChange={(event, value) => {
                                      this.handleEventTypeChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-12">
                                  <label className="form-label" htmlFor="multiStepsEmail">
                                    Event Location (City, State, Country)*
                                  </label>
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    onChange={this.handleLocationChange.bind(this)}
                                    value={this.state.location}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="collapsible-fullname"
                                  >
                                    Event Region
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.regionList}
                                    value={this.state.region}
                                    defaultValue={this.state.select}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, value) => {
                                      this.handleRegionChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="multiStepsEmail"
                                  >
                                    Event Timezone*
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.timeZoneListArray}
                                    value={this.state.timeZone}
                                    getOptionLabel={(option) =>
                                      option.displayText
                                    }
                                    defaultValue={this.state.timeZone}
                                    onChange={(event, value) => {
                                      this.handleTimeZoneChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        title=""
                                        required
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3 datePickerHelperText">
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-md-12" id="assetFormLabel">
                                      <label
                                        className="form-label MuiAutocomplete-label"
                                        htmlFor="collapsible-email"
                                      >
                                        Start Date*
                                        <span
                                          className="ms-1"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          (Texting First Day)
                                        </span>
                                      </label>

                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <ThemeProvider theme={materialTheme}>
                                          <DatePicker
                                            disabled
                                            value={this.state.startDate}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            inputVariant="outlined"
                                            // timeinputlabel="Time:"
                                            minDate={subDays(new Date(), 0)}
                                            format="MM/dd/yyyy"
                                            style={{ background: "#fff" }}
                                            onChange={this.handleStartDateChange.bind(
                                              this
                                            )}
                                            helperText={
                                              this.state.errorMassage
                                                ? "Start Date is Required"
                                                : ""
                                            }
                                            error={this.state.errorMassage}
                                            InputProps={{
                                              readOnly: true,
                                              endAdornment: (
                                                <InputAdornment position="end">
                                                  <IconButton>
                                                    <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                  </IconButton>
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                        </ThemeProvider>
                                      </MuiPickersUtilsProvider>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-12" id="assetFormLabel">
                                      <label
                                        className="form-label MuiAutocomplete-label"
                                        htmlFor="collapsible-jotitle"
                                      >
                                        End Date*
                                        <span
                                          className="ms-1"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          (Texting Last Day)
                                        </span>
                                      </label>
                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <ThemeProvider theme={materialTheme}>
                                          <DatePicker
                                            disabled
                                            value={this.state.endDate}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            inputVariant="outlined"
                                            minDate={subDays(new Date(), 0)}
                                            format="MM/dd/yyyy"
                                            style={{ background: "#fff" }}
                                            onChange={this.handleEndDateChange.bind(
                                              this
                                            )}
                                            helperText={
                                              this.state.endDateErrorMassage
                                                ? "End Date is Required"
                                                : ""
                                            }
                                            error={this.state.endDateErrorMassage}
                                            InputProps={{
                                              readOnly: true,
                                              endAdornment: (
                                                <InputAdornment position="end">
                                                  <IconButton>
                                                    <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                  </IconButton>
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                        </ThemeProvider>
                                      </MuiPickersUtilsProvider>
                                      {this.state.error ? (
                                        <lable className="errorMassageShow">
                                          End Date should be after Start Date
                                        </lable>
                                      ) : (
                                        ""
                                      )}

                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  {this.state.isDatechangeRequested && (
                                    <>
                                      {this.header?.isAp ? (
                                        <div className="row mt-3 datePickerHelperText">
                                          <div
                                            className="col-md-12 align-self-center"
                                            id="assetFormLabel"
                                          >
                                            <div className="row">
                                              <label
                                                className="col-sm-5 form-label pe-0"
                                                htmlFor="collapsible-email"
                                              >
                                                New Start Date
                                              </label>
                                              <div className="col-sm-7 MuiInputBase-root">
                                                {this.ptsDateFormat(
                                                  this.state.requestedStartDate
                                                )}
                                              </div>
                                            </div>
                                            <div className="row mt-3">
                                              <label
                                                className="col-sm-5 form-label pe-0"
                                                htmlFor="collapsible-jotitle"
                                              >
                                                New End Date
                                              </label>
                                              <div className="col-sm-7 MuiInputBase-root">
                                                {this.ptsDateFormat(
                                                  this.state.requestedEndDate
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="col-md-12 align-self-center"
                                            id="assetFormLabel"
                                          >
                                            <div className="row mt-3">
                                              <div className="col-sm-12">
                                                <Button
                                                  type="button"
                                                  variant="contained"
                                                  id="ptsButton"
                                                  style={{
                                                    background: "green",
                                                    color: "#fff",
                                                    marginRight: "1rem",
                                                    fontWeight: "bold",
                                                    textTransform: "capitalize",
                                                    padding: "2px 10px",
                                                    "&:hover": {
                                                      backgroundColor: "#1a3a5c", // Darker shade on hover
                                                    },
                                                  }}
                                                  onClick={this.approveDateChangeToBackend.bind(
                                                    this
                                                  )}
                                                >
                                                  Approve
                                                </Button>
                                                <Button
                                                  type="button"
                                                  variant="contained"
                                                  id="ptsButton"
                                                  // startIcon={<CloseIcon />}
                                                  onClick={this.rejectDateChangeToBackend.bind(
                                                    this
                                                  )}
                                                >
                                                  Deny
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="row mt-3 datePickerHelperText">
                                          <span style={{ color: "red" }}>
                                            Date Change Requested.
                                          </span>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {!this.state.isDatechangeRequested && (
                                    <div className="row mt-4 datePickerHelperText">
                                      <div
                                        className="col-md-12"
                                        id="assetFormLabel"
                                      >
                                        <Button
                                          variant="contained"
                                          // size="small"
                                          style={{
                                            background: "#d3d8de",
                                            color: "#353538",
                                            marginRight: "1rem",
                                            textTransform: "capitalize",
                                            padding: "2px 10px",
                                            width: "200px"
                                          }}
                                          startIcon={<EmailIcon />}
                                          onClick={this.sendEmailOpen.bind(this)}
                                        >
                                          Request Date Change
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6"
                              style={{
                                borderLeft: "1px solid #d3d3d3",
                                paddingLeft: "25px",
                              }}>
                              <div className="row">
                                <div className="col-md-12" id="assetFormLabel">
                                  <span
                                    className="fw-bold"
                                    style={{ color: "#06669a", fontSize: "18px" }}
                                  >
                                    Cvent settings - <span style={{ color: "#353538", fontSize: "12px" }}>Complete this section to use GivBee's webhook integration.</span>
                                  </span>
                                  <br></br>
                                  <span style={{ color: "#353538", fontSize: "12px" }}>Leave this section empty if you do not have the details or have not yet decided.</span>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label"
                                    htmlFor="collapsible-firstname"
                                    style={{ marginBottom: "0.15rem" }}
                                  >
                                    Cvent Event Code
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.ceventCode}
                                    onChange={this.handleCeventCodeChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label "
                                    htmlFor="collapsible-firstname"
                                    style={{ paddingBottom: "2px" }}
                                  >
                                    Cvent data carry over
                                  </label>

                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.cventDataCarryoverTypes}
                                    value={this.state.ceventCarryover}
                                    getOptionLabel={(option) => option.type}
                                    defaultValue={this.state.ceventCarryover}
                                    onChange={(event, value) => {
                                      this.handleCeventCarryoverChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-12" id="assetFormLabel">
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-firstname"
                                  >
                                    Want to send a text confirmation
                                    with each Cvent registration? Enter it here:
                                  </label>
                                  <textarea
                                    ref={this.textareaRef}
                                    value={
                                      this.state.registrationConfirmationText
                                    }
                                    onChange={this.handleRegistrationConfirmationTextChange.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    // rows="3"
                                    style={{
                                      overflow: "hidden",
                                      resize: "vertical",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      float: "right",
                                    }}
                                  >
                                    {Utils.trimLetters(this.state.registrationConfirmationText ?? "")}/{160 ?? 0}
                                  </span>
                                  <br></br>
                                  {160 <
                                    Utils.countLetters(this.state.registrationConfirmationText) && (
                                      <span
                                        className="danger ms-1"
                                        style={{ color: "red", fontSize: "14px" }}
                                      >
                                        Your message is limited to 160 characters.
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div
                          className="card-header d-flex align-items-center justify-content-between p-4"
                          id="assetCardHeader"
                        >
                          <div className="col-md-12">
                            <FormControlLabel
                              style={{
                                color: "#353538",
                                margin: "0",
                                padding: "0",
                                height: "15px",
                              }}
                              control={
                                <Checkbox
                                  variant="outlined"
                                  id="isAsset"
                                  checked={this.state.isConnectToCvent}
                                  value={this.state.isConnectToCvent}
                                  onChange={this.handleIsConnectToCventChange.bind(
                                    this
                                  )}
                                  style={{
                                    background: "none",
                                    marginBottom: "2px",
                                  }}
                                />
                              }
                              label={
                                <span className="form-label">
                                  Use Cvent Webhook Registration
                                </span>
                              }
                              labelPlacement="end"
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              {this.state.isConnectToCvent && (
                                <>
                                  <div className="row">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="form-label "
                                        htmlFor="collapsible-firstname"
                                        style={{ marginBottom: "0.15rem" }}
                                      >
                                        Enter the Cvent Event Code
                                      </label>
                                      <input
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.ceventCode}
                                        onChange={this.handleCeventCodeChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="MuiAutocomplete-label form-label "
                                        htmlFor="collapsible-firstname"
                                        style={{ paddingBottom: "2.5px" }}
                                      >
                                        What Cvent data do you want to carry over?
                                      </label>

                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.cventDataCarryoverTypes}
                                        value={this.state.ceventCarryover}
                                        getOptionLabel={(option) => option.type}
                                        defaultValue={this.state.ceventCarryover}
                                        onChange={(event, value) => {
                                          this.handleCeventCarryoverChange(value);
                                        }}
                                        inputprops={{
                                          style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="col-md-6" id="assetFormLabel">
                                      <label
                                        className="form-label "
                                        htmlFor="collapsible-firstname"
                                      >
                                        If you want to send a confirmation text msg
                                        with each new registration, enter it here:
                                      </label>
                                      <textarea
                                        ref={this.textareaRef}
                                        value={
                                          this.state.registrationConfirmationText
                                        }
                                        onChange={this.handleRegistrationConfirmationTextChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        // rows="2"
                                        style={{
                                          overflow: "hidden",
                                          resize: "vertical",
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          float: "right",
                                        }}
                                      >
                                        {Utils.trimLetters(this.state.registrationConfirmationText ?? "")}/{160 ?? 0}
                                      </span>
                                      <br></br>
                                      {160 <
                                        Utils.countLetters(this.state.registrationConfirmationText) && (
                                          <span
                                            className="danger ms-1"
                                            style={{ color: "red", fontSize: "14px" }}
                                          >
                                            Your message is limited to 160 characters.
                                          </span>
                                        )}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div >
                </div >
              </div >
              <div className="row d-flex align-items-center justify-content-between mb-4">
                <div className="col-sm-12 mt-3 text-center">
                  {/* {!this.state.isDatechangeRequested && (
                    <>
                      <Button
                        variant="contained"
                        // size="small"
                        style={{
                          background: "#d3d8de",
                          color: "#353538",
                          marginRight: "1rem",
                          textTransform: "capitalize",
                          padding: "2px 10px",
                        }}
                        startIcon={<EmailIcon />}
                        onClick={this.sendEmailOpen.bind(this)}
                      >
                        Request Date Change
                      </Button>{" "}
                      &nbsp;&nbsp;
                    </>
                  )} */}
                  <SaveButton btnName="Create" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton onClick={(e) => this.editCancel()} />
                </div>
              </div>
            </ValidatorForm >
          </div >
        </div >
        <Dialog
          open={this.state.sendEmailOpen}
          onClose={this.handleSendEmailClose.bind(this)}
          style={{ padding: "1em" }}
          maxWidth="xl"
          className="customerPlanDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Date Change Request</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleSendEmailClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.requestDateChange.bind(this)}
          >
            <DialogContent>
              <div className="col-md-12 p-3 pb-0">
                <div className="row datePickerHelperText justify-align-center">
                  <div className="col-md-9" id="assetFormLabel">
                    <label
                      className="form-label MuiAutocomplete-label"
                      htmlFor="collapsible-email"
                    >
                      New Start Date
                      <span
                        className="ms-1"
                        style={{ fontSize: "12px", fontWeight: "400" }}
                      >
                        (Texting First Day)
                      </span>
                    </label>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <ThemeProvider theme={materialTheme}>
                        <DatePicker
                          value={this.state.requestedStartDate}
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputVariant="outlined"
                          // timeinputlabel="Time:"
                          minDate={subDays(new Date(), 0)}
                          format="MM/dd/yyyy"
                          style={{ background: "#fff" }}
                          onChange={this.handleRequestStartDateChange.bind(
                            this
                          )}
                          helperText={
                            this.state.requestErrorMassage
                              ? "New Start Date is Required"
                              : ""
                          }
                          error={this.state.requestErrorMassage}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton>
                                  <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </ThemeProvider>
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="col-md-9 mt-2" id="assetFormLabel">
                    <label
                      className="form-label MuiAutocomplete-label"
                      htmlFor="collapsible-jotitle"
                    >
                      New End Date
                      <span
                        className="ms-1"
                        style={{ fontSize: "12px", fontWeight: "400" }}
                      >
                        (Texting Last Day)
                      </span>
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <ThemeProvider theme={materialTheme}>
                        <DatePicker
                          value={this.state.requestedEndDate}
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputVariant="outlined"
                          minDate={subDays(new Date(), 0)}
                          format="MM/dd/yyyy"
                          style={{ background: "#fff" }}
                          onChange={this.handleRequestEndDateChange.bind(this)}
                          helperText={
                            this.state.endDateErrorMassage
                              ? "New End Date is Required"
                              : ""
                          }
                          error={this.state.endDateErrorMassage}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton >
                                  <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </ThemeProvider>
                    </MuiPickersUtilsProvider>
                  </div>
                  {this.state.requestError ? (
                    <lable className="errorMassageShow">
                      New End Date should be after New Start Date
                    </lable>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div class="col-md-12 text-center m-3">
                <Button
                  type="submit"
                  style={{
                    padding: "3px 10px",
                    background: "#37517e",
                    color: "#fff",
                    fontSize: "14px",
                    textTransform: "capitalize",
                  }}
                >
                  Send Request<i className="fa fa-paper-plane ms-2"></i>
                </Button>
              </div>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }

  viewEvent() {
    const timeZone = this.eventTimeZone?.name; // e.g. "Asia/Kolkata"
    const currentTime = timeZone
      ? new Date().toLocaleTimeString("en-IN", {
        timeZone,
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      : "";
    const timeZoneAbbr = this.eventTimeZone?.abbreviation || "IST";

    return (
      <>
        <div
          className="row m-0"
          style={{
            maxWidth: "100%",
            minWidth: Utils.getBrowserType() === "Safari" && "93%",
            zIndex: "1040",
            position: "fixed",
            width:
              Utils.getBrowserType() === "Chrome" ||
                Utils.getBrowserType() === "Edge"
                ? "-webkit-fill-available"
                : "-moz-available",
            backgroundColor: "#d9dee3",
            color: "#fff",
            padding: "5px 0px",
          }}
        >
          <div className="col-md-3 align-self-center">
            {this.state.getUpdatePermission &&
              <EditIconButton
                pageId="Event"
                onClick={this.editEventDetails.bind(this)}
              />
            }
          </div>
          <div className="col-12 col-md-6 justify-content-center align-items-center p-0">
            <div
              className="d-flex flex-wrap justify-content-center align-items-center text-center"
              id="givbeeText"
              style={{
                fontSize: "16px",
                lineHeight: "1.3",
                maxWidth: "100%",
              }}
            >
              <span
                className="fw-bold"
                style={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {this.eventBusinessDomain?.name}
              </span>
            </div>
            <div
              className="d-flex flex-wrap justify-content-center align-items-center text-center"
              id="givbeeText"
              style={{
                lineHeight: "1.3",
                maxWidth: "100%",
              }}
            >
              <span
                className=" me-2"
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "12px",
                }}
              >
                {this.eventBusinessDomain?.startDate
                  ? this.ptsDateFormat(this.eventBusinessDomain.startDate)
                  : ""}
                &nbsp;
                thru
                &nbsp;
                {this.eventBusinessDomain?.endDate
                  ? this.ptsDateFormat(this.eventBusinessDomain.endDate)
                  : ""}
              </span>
              <Tooltip
                title={`Current ${timeZoneAbbr} time: ${currentTime}`}
                arrow
              >
                <span
                  className="anchortag"
                  style={{
                    cursor: "pointer",
                    color: "#337AB7",
                    fontSize: "12px",
                  }}
                  onClick={this.editEventDetails.bind(this)}
                >
                  {this.eventTimeZone?.displayText}
                </span>
              </Tooltip>
            </div>
          </div>

          <div className="col-md-3 align-self-end m-0" id="givbeeText"
            style={{ textAlign: "end", fontSize: "12px" }}>
            {Utils.equalsIgnoreCase(this.planType, "Onetime") ? (
              <div className="pe-3">
                {this.smsCredits !== null && this.smsCredits !== undefined
                  ? `Event credits used: ${Utils.formatWithCommas(
                    this.smsCredits?.consumedCredits
                  )}/${Utils.formatWithCommas(
                    this.smsCredits?.availableCredits
                  )}`
                  : ""}
                {!this.accountSettings?.enableOverages &&
                  <span className="ms-1">
                    <img src={OveragesLockIcon}
                      style={{
                        height: "16px",
                        marginBottom: "5px",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                }
              </div>
            ) :
              <div className="pe-3">
                {this.smsCredits !== null && this.smsCredits !== undefined
                  ? `Event credits used: ${Utils.formatWithCommas(
                    this.smsCredits?.consumedCredits
                  )}`
                  : ""}
              </div>}
          </div>
        </div >
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          // onHide={this.close}
          style={{ padding: "1em" }}
          className="deleteEventDialogue"
        >
          <DialogContent>
            {this.state.eventStatus?.status === "Active" ? (
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "18px" }}>
                  {this.state.eventStatus?.status === "Active"
                    ? "You are about to permanently delete the Event"
                    : "By deleting this event, all of the event data (including send history) will be deleted."}
                  <br></br>
                  <span
                    style={{
                      color: " #37517e",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    “{this.state.eventName}”.
                  </span>
                </p>
              </span>
            ) : (
              <span style={{ textAlign: "start" }}>
                <p className="m-0" style={{ fontSize: "18px" }}>
                  By deleting this event, all of the event data (including send
                  history) will be deleted.
                </p>
              </span>
            )}
          </DialogContent>
          <DialogActions
            style={{
              // marginTop: "1em",
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={this.deleteEventToBackend.bind(this)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  smsCredits: state.businessDomain?.smsCredits,
  eventBusinessDomain: state.businessDomain?.eventState,
});
export default connect(mapStateToProps)(withRouter(Event));
